/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { InlineNotification, Typography2 } from '@coursera/cds-core';
import { SvgGoogle } from '@coursera/coursera-ui/svg';

import LinkButton from 'bundles/third-party-auth/components/AccountLink/LinkButton';
import { useAccountLink } from 'bundles/third-party-auth/components/AccountLink/hooks/useAccountLink';

import _t from 'i18n!nls/third-party-auth';

const styles = {
  row: css`
    display: flex;
    flex-direction: column;
  `,
  topRow: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--cds-spacing-150);
  `,
  label: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-150);
    margin: 0;
  `,
  liveRegion: css`
    min-height: 0;

    &:not(:empty) {
      margin-top: var(--cds-spacing-200);
    }
  `,
};

const AccountLinkGoogle = () => {
  const { isLinked, isDisabled, isLoading, errorMessage, successMessage, handleLink, handleDelink } =
    useAccountLink('google');

  return (
    <div css={styles.row} data-testid="account-link-google">
      <div css={styles.topRow}>
        <Typography2 variant="subtitleMedium" component="h3" css={styles.label}>
          <SvgGoogle size={20} aria-hidden />
          {_t('Google')}
        </Typography2>
        <LinkButton
          provider="google"
          linked={isLinked}
          disabled={isDisabled}
          loading={isLoading}
          onLink={handleLink}
          onDelink={() => handleDelink()}
        />
      </div>
      <div role="status" aria-live="polite" aria-atomic="true" css={styles.liveRegion}>
        {successMessage && <InlineNotification severity="success">{successMessage}</InlineNotification>}
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" css={styles.liveRegion}>
        {errorMessage && <InlineNotification severity="error">{errorMessage}</InlineNotification>}
      </div>
    </div>
  );
};

export default AccountLinkGoogle;
